<script lang="ts">
  import type { AppContext } from '../app';
  import { cue } from '../audio/sound';
  import { t } from '../i18n';
  import { currentDate, photoMode } from '../state/stores';
  import Icon from './icons/Icon.svelte';

  // Photo mode (S2-20): the HUD and the labels step aside; drag to frame the shot, then save or share it.
  let { ctx }: { ctx: AppContext } = $props();
  let busy = $state(false);

  async function capture(): Promise<void> {
    busy = true;
    try {
      const blob = await ctx.scene.capture();
      if (!blob) return;
      cue('click');
      const name = `zeitflug-${new Date($currentDate).toISOString().slice(0, 10)}.png`;
      const file = new File([blob], name, { type: 'image/png' });
      if (navigator.canShare?.({ files: [file] })) {
        await navigator.share({ files: [file], title: 'Zeitflug' }).catch(() => {});
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }
    } finally {
      busy = false;
    }
  }

  function onKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape') photoMode.set(false);
  }
</script>

<svelte:window onkeydown={onKeydown} />

<div class="panel toolbar" role="toolbar" aria-label={$t('photo.label')}>
  <button type="button" class="capture" disabled={busy} onclick={capture}>{$t('photo.capture')}</button>
  <button type="button" class="exit" aria-label={$t('photo.exit')} onclick={() => photoMode.set(false)}>
    <Icon name="close" />
  </button>
</div>

<style>
  .toolbar {
    position: fixed;
    left: 50%;
    bottom: calc(env(safe-area-inset-bottom) + 16px);
    transform: translateX(-50%);
    display: flex;
    align-items: stretch;
  }
  .capture {
    min-height: var(--touch);
    padding: 0 18px;
    background: var(--accent);
    color: var(--on-accent);
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: var(--track-caps);
    text-transform: uppercase;
  }
  .exit {
    width: var(--touch);
    display: grid;
    place-items: center;
    border-left: var(--rule-w) solid var(--rule);
  }
</style>
